import { useContext, createContext } from 'react';
export const ConfigContext = /*#__PURE__*/createContext(null);
export const useConfig = () => useContext(ConfigContext) || {
  locale: 'en',
  regionalFormat: 'en'
};
//# sourceMappingURL=config-context.js.map